import React from 'react'

interface DiscountPillProps {
  label: string
}

/** Green "50% OFF" chip shown next to a discounted price. */
function DiscountPill({ label }: DiscountPillProps) {
  return (
    <span className='whitespace-nowrap rounded-pill bg-success-50 px-2 py-0.5 text-10 font-bold text-success-700'>
      {label}
    </span>
  )
}

export default DiscountPill
